export default "__VITE_ASSET__B$lqp_6t__"